module.exports = __webpack_public_path__ + "static/media/call.dc1a7d51.svg";